import { Outlet, Link } from 'react-router-dom';
import { FiShoppingCart, FiSettings, FiLogOut, FiArchive, FiMenu, FiX } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

const Layout = () => {
  const navigate = useNavigate();
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  
  const handleLogout = () => {
    sessionStorage.clear();
    navigate('/admin/login');
  };

  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Sidebar */}
      <aside
        className={`fixed top-0 left-0 z-50 w-64 bg-white h-screen shadow-lg p-4 transform transition-transform duration-300 
          ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"} 
          md:translate-x-0 md:static md:shadow-lg`}
      >
        <div className="mb-8 flex justify-between items-center">
          <div>
            <h1 className="text-2xl font-bold text-gray-800">Admin</h1>
            <p className="text-sm text-gray-500">Super Admin Panel</p>
          </div>
          {/* Close button for mobile */}
          <button onClick={() => setSidebarOpen(false)} className="md:hidden">
            <FiX className="h-6 w-6" />
          </button>
        </div>

        <nav className="space-y-2">
          <Link
            to="enquiries"
            className="flex items-center p-2 text-gray-700 hover:bg-gray-100 rounded"
          >
            <FiShoppingCart className="mr-3" /> Enquiries
          </Link>
          <Link
            to="blogs"
            className="flex items-center p-2 text-gray-700 hover:bg-gray-100 rounded"
          >
            <FiArchive className="mr-3" /> Blogs
          </Link>
          <Link
            to="quotationSettings"
            className="flex items-center p-2 text-gray-700 hover:bg-gray-100 rounded"
          >
            <FiSettings className="mr-3" /> Quotation settings
          </Link>
        </nav>

        <button
          className="mt-8 w-full flex items-center p-2 text-red-600 hover:bg-red-50 rounded"
          onClick={handleLogout}
        >
          <FiLogOut className="mr-3" /> Logout
        </button>
      </aside>

      {/* Main Content */}
      <main className="flex-1 p-8 md:ml-64">
        {/* Hamburger menu for mobile */}
        <div className="md:hidden mb-4">
          <button
            onClick={() => setSidebarOpen(true)}
            className="p-2 border rounded-md"
          >
            <FiMenu className="h-6 w-6" />
          </button>
        </div>
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
